export const DeviceType = {
  ANDROID_PUSH: 'ANDROID_PUSH',
  APPLE_PUSH: 'APPLE_PUSH',
  BLACKBERRY_PUSH: 'BLACKBERRY_PUSH',
  CHAT: 'CHAT',
  EMAIL: 'EMAIL',
  FAX: 'FAX',
  GENERIC: 'GENERIC',
  TEXT_PAGER: 'TEXT_PAGER',
  TEXT_PHONE: 'TEXT_PHONE',
  VOICE: 'VOICE',
  VOICE_IVR: 'VOICE_IVR',
  VIRTUAL: 'VIRTUAL',
  BES: 'BES',
  IM: 'IM',
  BROWSER: 'BROWSER',
  NUMERIC_PAGER: 'NUMERIC_PAGER',
  MS_TEAMS: 'MS_TEAMS',
  SLACK: 'SLACK',
};

export const NotificationDeviceTypeValues = [
  DeviceType.ANDROID_PUSH,
  DeviceType.APPLE_PUSH,
  DeviceType.EMAIL,
  DeviceType.FAX,
  DeviceType.TEXT_PAGER,
  DeviceType.TEXT_PHONE,
  DeviceType.VOICE,
  DeviceType.VOICE_IVR,
  DeviceType.MS_TEAMS,
  DeviceType.SLACK,
];

export const DeviceTypesOnlyAvailableForPaidInstances = [
  DeviceType.TEXT_PHONE,
  DeviceType.VOICE,
];

export const DeviceNamesOnlyAvailableForPaidInstances = [
  'Home Phone',
  'Mobile Phone',
  'SMS Phone',
  'Work Phone',
];

export const NotificationDeviceTypes = new Set();
NotificationDeviceTypes.add(DeviceType.ANDROID_PUSH);
NotificationDeviceTypes.add(DeviceType.APPLE_PUSH);
NotificationDeviceTypes.add(DeviceType.EMAIL);
NotificationDeviceTypes.add(DeviceType.FAX);
NotificationDeviceTypes.add(DeviceType.GENERIC);
NotificationDeviceTypes.add(DeviceType.TEXT_PAGER);
NotificationDeviceTypes.add(DeviceType.TEXT_PHONE);
NotificationDeviceTypes.add(DeviceType.VOICE);
NotificationDeviceTypes.add(DeviceType.VOICE_IVR);
NotificationDeviceTypes.add(DeviceType.MS_TEAMS);
NotificationDeviceTypes.add(DeviceType.SLACK);

export const DevicesNotSupportedForTesting = new Set();
DevicesNotSupportedForTesting.add(DeviceType.VIRTUAL);
DevicesNotSupportedForTesting.add(DeviceType.BES);
DevicesNotSupportedForTesting.add(DeviceType.IM);
DevicesNotSupportedForTesting.add(DeviceType.BROWSER);
DevicesNotSupportedForTesting.add(DeviceType.NUMERIC_PAGER);

export const AllDevicesSymbol = Symbol('ALL DEVICES');

export const NotificationDevicesTranslationIds = {
  [DeviceType.ANDROID_PUSH]: 'MOBILE_APP',
  [DeviceType.APPLE_PUSH]: 'MOBILE_APP',
  [DeviceType.CHAT]: 'CHAT_APP',
  [DeviceType.EMAIL]: 'EMAIL',
  [DeviceType.FAX]: 'FAX',
  [DeviceType.GENERIC]: 'GENERIC_DEVICE',
  [DeviceType.TEXT_PAGER]: 'TEXT_PAGER',
  [DeviceType.TEXT_PHONE]: 'SMS',
  [DeviceType.VOICE]: 'VOICE',
  [DeviceType.VOICE_IVR]: 'VOICE_IVR',
  [DeviceType.MS_TEAMS]: 'MS_TEAMS',
  [DeviceType.SLACK]: 'SLACK',
};

export const DEVICE_STATUS_TESTED = 'TESTED';
export const DEVICE_STATUS_ACTIVE = 'ACTIVE';

export const DeviceCategories = {
  MOBILE: 'MOBILE',
  EMAIL: 'EMAIL',
  VOICE: 'VOICE',
  OTHER: 'OTHER',
};

export const DeviceCategoryValues = [
  DeviceCategories.MOBILE,
  DeviceCategories.EMAIL,
  DeviceCategories.VOICE,
  DeviceCategories.OTHER,
];

export const DeviceCategoryIcons = {
  [DeviceCategories.MOBILE]: 'icon-comment',
  [DeviceCategories.VOICE]: 'icon-phone',
  [DeviceCategories.OTHER]: 'icon-email',
};

export const CATEGORY_BY_DEVICE_TYPE = {
  ANDROID_PUSH: 'MOBILE',
  APPLE_PUSH: 'MOBILE',
  TEXT_PHONE: 'MOBILE',
  TEXT_PAGER: 'MOBILE',
  VOICE: 'VOICE',
  VOICE_IVR: 'VOICE',
};

export const DeviceFilterType = {
  INPUT: 'INPUT',
  PICKER: 'PICKER',
};

export const FreeTrialDeviceTypes = {
  WORK_EMAIL: 'Work Email',
};

// Used when building new devices before they're saved:
export const NEW_DEVICE_ID = 'newDeviceId';

export const isFreeTierDevice = deviceType =>
  [
    DeviceType.EMAIL,
    DeviceType.APPLE_PUSH,
    DeviceType.ANDROID_PUSH,
    DeviceType.BLACKBERRY_PUSH,
  ].includes(deviceType);
